// user
export const GET_USER_AUTH = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/login"
export const GET_USERS = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getUsers"
export const ADD_USER = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addUser"
export const EDIT_USER = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editUser"
export const DELETE_USER = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteUser"

// audit log
export const GET_AUDIT = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getAudit"

// programs
export const GET_PROGRAMS = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getPrograms"
export const ADD_PROGRAM = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addProgram"
export const EDIT_PROGRAM = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editProgram"
export const DELETE_PROGRAM = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteProgram"

// neurelis resources
export const GET_NEURELIS_RESOURCES = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisResources"
export const ADD_NEURELIS_RESOURCE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisResource"
export const EDIT_NEURELIS_RESOURCE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisResource"
export const DELETE_NEURELIS_RESOURCE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisResource"
export const GET_RESOURCE_CATEGORIES = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisResourcesTypes"

// neurelis msl
export const GET_NEURELIS_MSL = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisMSL"
export const ADD_NEURELIS_MSL = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisMSL"
export const EDIT_NEURELIS_MSL = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisMSL"
export const DELETE_NEURELIS_MSL = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisMSL"

// neurelis podcasts
export const GET_NEURELIS_PODCASTS = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisPodcasts"
export const ADD_NEURELIS_PODCAST = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisPodcast"
export const EDIT_NEURELIS_PODCAST = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisPodcast"
export const DELETE_NEURELIS_PODCAST = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisPodcast"
export const GET_NEURELIS_AVAILABLE_PODCASTS = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisPodcastsDirectoryListing"

// neurelis events
export const GET_NEURELIS_EVENTS = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisEvents"
export const ADD_NEURELIS_EVENT = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisEvent"
export const EDIT_NEURELIS_EVENT = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisEvent"
export const DELETE_NEURELIS_EVENT = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisEvent"

// neurelis homepage
export const GET_NEURELIS_HOMEPAGES = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisHomepageImages"
export const ADD_NEURELIS_HOMEPAGE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisHomepageImage"
export const EDIT_NEURELIS_HOMEPAGE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisHomepageImage"
export const DELETE_NEURELIS_HOMEPAGE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisHomepageImage"

// neurelis search 
export const GET_NEURELIS_SEARCHES = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisSearches"
export const ADD_NEURELIS_SEARCH = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisSearch"
export const EDIT_NEURELIS_SEARCH = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisSearch"
export const DELETE_NEURELIS_SEARCH = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisSearch"

// neurelis Micro resources
export const GET_NEURELISMICRO_RESOURCES = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisMicroResources"
export const ADD_NEURELISMICRO_RESOURCE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisMicroResource"
export const EDIT_NEURELISMICRO_RESOURCE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisMicroResource"
export const DELETE_NEURELISMICRO_RESOURCE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisMicroResource"
export const GET_NEURELISMICRO_RESOURCE_CATEGORIES = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisMicroResourcesTypes"

// neurelis Micro homepage
export const GET_NEURELISMICRO_HOMEPAGES = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisMicroHomepageImages"
export const ADD_NEURELISMICRO_HOMEPAGE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisMicroHomepageImage"
export const EDIT_NEURELISMICRO_HOMEPAGE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisMicroHomepageImage"
export const DELETE_NEURELISMICRO_HOMEPAGE = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteMicroNeurelisHomepageImage"

// neurelis Micro events
export const GET_NEURELISMICRO_EVENTS = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/getNeurelisMicroEvents"
export const ADD_NEURELISMICRO_EVENT = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/addNeurelisMicroEvent"
export const EDIT_NEURELISMICRO_EVENT = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/editNeurelisMicroEvent"
export const DELETE_NEURELISMICRO_EVENT = "/rest/" + process.env.REACT_APP_RESTPATH + "/v1/deleteNeurelisMicroEvent"

// file locations to actual sites
export const NEURELIS_IMAGE_PATH = (process.env.REACT_APP_RESTPATH === 'crgDev' ? "https://neurelis.addesso.net/images/" : "https://www.neurelismedicalaffairs.com/images/")
export const NEURELISMICRO_IMAGE_PATH = (process.env.REACT_APP_RESTPATH === 'crgDev' ? "https://neurelis-ms.addesso.net/images/" : "https://neurelis-ms.addesso.net/images/")
export const NEURELIS_PDF_PATH = (process.env.REACT_APP_RESTPATH === 'crgDev' ? "https://neurelis.addesso.net/pdfs/" : "https://www.neurelismedicalaffairs.com/pdfs/")
export const NEURELISMICRO_PDF_PATH = (process.env.REACT_APP_RESTPATH === 'crgDev' ? "https://neurelis-ms.addesso.net/pdfs/" : "https://neurelis-ms.addesso.net/pdfs/")